import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Switch, withRouter } from 'react-router-dom';
import { ManorProvider } from '@comparethemarketau/manor-provider';
import { useBrandingService } from './hooks/useBrandingService';

/**
 * Wrap provided children with ManorProvider if running in browser, for SSR, render children.
 * @param props - props for the ManorProvider component
 * @param children - children to be rendered
 * @returns {*}
 */
// eslint-disable-next-line react/prop-types
const SafeManorProvider = ({ children, theme }) => (typeof window !== 'undefined' ? <ManorProvider theme={theme}>{children}</ManorProvider> : children);

const _App = (props) => {
    const { routes, history } = props;
    const [isLoading, setIsLoading] = useState(true);
    const { isBrandThemeSet, manorTheme } = useBrandingService();

    // Hide the loading spinner when the brand theme is set
    // This is returned from the useBrandingServiceHook after calling switchTheme
    useEffect(() => {
        if (isLoading && isBrandThemeSet) {
            setIsLoading(false);
        }
    }, [isBrandThemeSet]);

    const keyframesStyle = `
            @keyframes spin {
                to {
                    transform: rotate(360deg);
                }
            }
        `;

    const spinnerStyle = {
        margin: '0 auto',
        width: '72px',
        height: '72px',
        borderRadius: '50%',
        border: '8.5px solid #0B60B7',
        borderBottomColor: 'transparent',
        animation: 'spin 1s linear infinite'
    };
    // Will break preload if allowed on results page
    if (isLoading && (history.location.pathname !== '/car-insurance/journey/results')
        && (history.location.pathname !== '/home-contents-insurance/journey/results')) {
        return (
            <div style={{
                textAlign: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                marginTop: '20vh',
                width: '100%',
                fontFamily: 'Arial, Helvetica, sans-serif'
            }}>
                <h2 style={{
                    marginBottom: '60px',
                    fontSize: '28px',
                    fontWeight: '600',
                    lineHeight: '136%'
                }}>
                    Just a moment...
                </h2>
                <div style={{ ...spinnerStyle }}>
                    <style>{ keyframesStyle }</style>
                </div>
            </div>
        );
    }

    return (
        <SafeManorProvider theme={manorTheme}>
            <div style={ { height: '100%' } } key="appDiv">
                <Switch key="Switch">
                    { routes }
                </Switch>
            </div>
        </SafeManorProvider>
    );
};

_App.propTypes = {
    routes: PropTypes.array.isRequired,
    history: PropTypes.object
};

// withRouter is used so that the history, match and location are passed to the components for the matching route
// see https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/api/withRouter.md
export const App = withRouter(_App);
